import { SupportTicketPaymentMethod } from './SupportTicketPayment.js';

/**
 * Plain object Packlink's API response representation.
 *
 */

class SupportTicketPaymentMapper {
  static createModelFromResponse(response) {
    const type = this.getTypeFromPaymentMethod(response);
    return {
      type,
      data: this.createPaymentEntityDataFromResponse(type, response)
    };
  }
  static getTypeFromPaymentMethod(response) {
    if (response.bank) {
      return SupportTicketPaymentMethod.BANK;
    } else if (response.paypal) {
      return SupportTicketPaymentMethod.PAYPAL;
    } else {
      return SupportTicketPaymentMethod.UNKNOWN;
    }
  }
  static createPaymentEntityDataFromResponse(type, response) {
    switch (type) {
      case SupportTicketPaymentMethod.PAYPAL:
        return response.paypal;
      case SupportTicketPaymentMethod.BANK:
        {
          const {
            account_holder,
            ...otherData
          } = response.bank;
          return {
            accountHolder: account_holder,
            ...otherData
          };
        }
      default:
        return undefined;
    }
  }
  static createApiPayload(_ref) {
    let {
      type,
      data
    } = _ref;
    switch (type) {
      case SupportTicketPaymentMethod.PAYPAL:
        return {
          paypal: data
        };
      case SupportTicketPaymentMethod.BANK:
        {
          const {
            accountHolder,
            ...otherData
          } = data;
          return {
            bank: {
              account_holder: accountHolder,
              ...otherData
            }
          };
        }
      default:
        return {
          paypal: undefined,
          bank: undefined
        };
    }
  }
}

export { SupportTicketPaymentMapper };
//# sourceMappingURL=SupportTicketPaymentMapper.js.map
